import { useTranslation } from 'react-i18next'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { useMediaQuery } from 'usehooks-ts'


import { useFetchCategoriesPreview } from '@entities/Categories'
import { PreviewStories } from '@entities/Stories'

import { CartPreview } from '@features/cart'
import { useAddressStore } from '@features/shipping-methods'

import { CategoriesSidebar } from '@widgets/categories-branch'
import CategoriesPreview from '@widgets/categories-preview/CategoriesPreview'




import SEO from '@shared/components/SEO'
import { BRAND_NAME } from '@shared/contants/app'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import Wrapper from '@shared/ui/wrapper'


import styles from './styles.module.scss'

function CatalogPageLoading () {
  const isTablet = useMediaQuery('(max-width: 991px)')

  return (
    <SkeletonTheme>
      <div className={styles.skeletonWrap}>
        <Skeleton
          width={166}
          height={38}
          style={{
            borderRadius: 12,
            marginBottom: 24,
          }}
        />
        <div className={styles.skeleton}>
          {Array.from({
            length: 19,
          }).map((_, index) => {
            return (
              <Skeleton
                style={{
                  borderRadius: 16,
                  aspectRatio: !isTablet && index === 0 ? '2.075/1' : '1/1',
                }}
                key={index}
              />
            )
          })}
        </div>
      </div>
    </SkeletonTheme>
  )
}

export default function CatalogPage () {
  const { t: tn } = useTranslation('navigation')
  const { t: ts } = useTranslation('seo')
  const isTablet = useMediaQuery('(max-width: 991px)')
  const { shopId } = useAddressStore()
  const { categories, loading: categoriesLoading } = useFetchCategoriesPreview({
    shopId,
    style: '600xauto'
  })

  return (
    <Container>
      <SEO
        title={ts('catalog.title', { brand: BRAND_NAME })}
        description={ts('catalog.description', { brand: BRAND_NAME })}
      />
      <PageGrid aside={<CartPreview />}>
        <Wrapper className={styles.wrapper}>
          <div className={styles.grid}>
            <Breadcrumbs
              className={styles.breadcrumbs}
              links={[
                {
                  title: tn('catalog'),
                },
              ]}
            />
            {!isTablet && (
              <div className={styles.aside}>
                <CategoriesSidebar className={styles.aside__content} />
              </div>
            )}
            {!categoriesLoading && (
              <div className={styles.content}>
                <div className={styles['page-top']}>
                  <PreviewStories />
                </div>

                <h1 className={styles.title}>{tn('catalog')}</h1>

                {categories.length > 0 && (
                  <CategoriesPreview
                    categories={categories}
                    classNameGrid={styles['categories-grid']}
                    classNameItem={styles['categories-item']}
                    classNamePlug={styles['plug']}
                  />
                )}
              </div>
            )}
            {categoriesLoading && <CatalogPageLoading />}
          </div>
        </Wrapper>
      </PageGrid>
    </Container>
  )
}
